import Resource from '../../../domain/resource/Resource'
import {ResourceResponse} from '../types'

export const toResource = ({url}: ResourceResponse): Resource => {
  return {url}
}
